module.exports = __webpack_public_path__ + "static/media/fileSuccess.b94ea7af.gif";